
const Cards = ({img,user,amount,storage,capacity,limit}) =>{
    return(
     <div className='flex flex-col justify-center items-center'>
        <img className='' src={img} alt=""/>
        <h2 className='font-bold'>{user}</h2>
        <h1 className='font-bold py-2'>{amount}</h1>
        <div className='w-full'>
         <p className='border-b py-2'>{storage}</p>
         <p className='border-b py-2'>{limit}</p>
         <p className='border-b py-2'>{capacity}</p>
        </div>
        <button className="btn">Start Trial</button>
     </div>
    )
}
export default Cards;